import { inject, Injectable, provideAppInitializer } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconsList } from '../constants';

@Injectable({ providedIn: 'root' })
export class IconService {
  private readonly _sanitizer = inject(DomSanitizer);

  private _icons: Record<string, string> = {};

  getIcon(iconName: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this._icons[iconName] || '');
  }

  async loadAll(): Promise<void> {
    const loaders = IconsList.map(async (name) => {
      await this._fetchIcon(name);
    });

    await Promise.all(loaders);
    return void 0;
  }

  private async _fetchIcon(name: string) {
    try {
      const url = `assets/icons/${name}.svg`;
      const res = await fetch(url);
      const svg = await (res.ok ? res.text() : Promise.reject(new Error(`Icon not found: ${url}`)));
      if (svg) {
        this._icons[name] = svg;
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export function provideIconInitializer() {
  return provideAppInitializer(() => {
    const service = inject(IconService);
    return service.loadAll();
  });
}
